module.exports = __webpack_public_path__ + "static/img/106_TO8_1793.d3391f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/106_TO8_1793.jpg
// module id = 9xTn
// module chunks = 0